import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconPlay';
/** Renders an SVG icon. */
const SvgPlay = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M8 7.883A1.5 1.5 0 0 1 10.081 6.5l.19.097L23.8 14.714a1.5 1.5 0 0 1 0 2.572l-13.53 8.117A1.5 1.5 0 0 1 8 24.117zm2 15.35L22.056 16 10 8.766v14.468Z"
      />
    </svg>
  );
};
SvgPlay.displayName = displayName;
export default SvgPlay;
